export const hasWindow = () => {
  try {
    return typeof window !== 'undefined' && typeof document !== 'undefined'
  } catch {
    return false
  }
}
